// src/App.tsx
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Auth from "./pages/Auth";
import Events from "./pages/Events";
import EventSubscription from "./pages/EventSubscription";
import AdminHome from "./pages/AdminHome";
import Layout from "./Layout";
import { EventProvider } from "./context/EventContext";
import AdminEventDetails from "./pages/AdminEventDetails";
import DesignSystem from "./style/DesignSystem";

const ProtectedRoute: React.FC<{
  element: React.ReactElement;
  adminOnly?: boolean;
}> = ({ element, adminOnly = false }) => {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;

  return element;
};

export const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <EventProvider>
          <Layout>
            <Routes>
              <Route path="/design" element={<DesignSystem />} />
              <Route path="/auth" element={<Auth />} />
              <Route
                path="/"
                element={<ProtectedRoute element={<Events />} />}
              />
              <Route
                path="/event/:eventId"
                element={<ProtectedRoute element={<EventSubscription />} />}
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute element={<AdminHome />} adminOnly={true} />
                }
              />
              <Route
                path="/admin/event/:eventId"
                element={
                  <ProtectedRoute
                    element={<AdminEventDetails />}
                    adminOnly={true}
                  />
                }
              />
            </Routes>
          </Layout>
        </EventProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
